export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7049a2242c8a5a77f798e8d4d0c7170d87c06b09f9&name=pushAdClickData!'